// import external dependencies
import 'custom-event-polyfill';
import 'jquery';
// Import everything from autoload
import './autoload/_bootstrap.js';
import 'jquery-lazy/jquery.lazy';
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/product';
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Single product
  singleProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js